'use strict';

import ngCookies from 'angular-cookies';
import moment from 'angular-moment';
import OemService from '../../api/oem/oem.service';

export function AuthUtil($rootScope, $cookies, moment, OemService) {
  function is_admin(role) {
    return role === 'admin' || role === 'oem';
  }

  function is_operator(role) {
    return role === 'operator';
  }

  function is_viewer(role) {
    return role === 'viewer' || role === 'limited_viewer';
  }

  function is_limited_viewer(role) {
    return role === 'limited_viewer';
  }

  return {
    setUserInfo: function (user) {
      $rootScope.username = user.email;
      $rootScope.is_admin = is_admin(user.role);
      $rootScope.is_operator = is_operator(user.role);
      $rootScope.is_viewer = is_viewer(user.role);
      $rootScope.is_limited_viewer = is_limited_viewer(user.role);

      $rootScope.oemKey = $cookies.get('oemKey');

      let oemPromise = null;
      if (user.configName === 'oemUser') {
        oemPromise = OemService.oem_api.index().$promise;
      } else {
        oemPromise = OemService.api.index().$promise;
      }

      oemPromise.then(response => {
        $rootScope.demandEnabled = response.demand_alert_enabled;

        if (!$rootScope.oemKey) {
          $cookies.put('oemKey', response.logo_folder_name, {expires: moment().add(1, 'day').toDate()});
          $rootScope.oemKey = response.logo_folder_name;
        }

        if (!$rootScope.manualFile) {
          $cookies.put('manualFile', response.manual_file_name, {expires: moment().add(1, 'day').toDate()});
          $rootScope.manualFile = response.manual_file_name;
        }
      });
    },
    resetUserInfo: function () {
      $rootScope.username = '';
      $rootScope.is_admin = $rootScope.is_operator = $rootScope.is_viewer = false;
      $rootScope.oemKey = null;
      $rootScope.manualFile = null;
      $cookies.remove('oemKey');
      $cookies.remove('manualFile');
    }
  };
}

export default angular.module('leptonApp.AuthUtil', [ngCookies, moment, OemService])
  .factory('AuthUtil', ['$rootScope', '$cookies', 'moment', 'OemService', AuthUtil])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/auth_util/auth_util.js